import React from "react";

import { Link } from "react-router-dom";
import { useFormContext } from "react-hook-form";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";

import { ReactComponent as CenterParcs } from "../../assets/icons/CenterParcs.svg";

type LoginProps = {
  onSubmit: (data: any) => void;
  t: any;
};

const CenterParcsLogin: React.FC<LoginProps> = ({ onSubmit, t }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div
      className="row vh-100 d-flex align-items-center justify-content-center"
      style={{ background: "#b1eda6" }}
    >
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={5} lg={6} md={7} sm={9} xs={11}>
            <div className="text-center mb-5 pb-5">
              <CenterParcs style={{ maxWidth: "450px", width: "100%" }} />
            </div>

            <div
              className="p-4 p-md-5 shadow-sm"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                borderRadius: "20px",
              }}
            >
              <Form onSubmit={onSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label
                    className="fw-bold mb-2"
                    style={{ color: "#045e51" }}
                    htmlFor="centerparcs-email"
                  >
                    {t("login:form.email.label")}
                  </Form.Label>
                  <Form.Control
                    type="email"
                    id="centerparcs-email"
                    size="lg"
                    className="border-0 rounded-pill"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                      border: "2px solid #045e51",
                      color: "#045e51",
                    }}
                    placeholder={t("login:form.email.placeholder")}
                    autoComplete="username"
                    {...register("email")}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {typeof errors.email?.message === "string"
                      ? errors.email.message
                      : null}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label
                    className="fw-bold mb-2"
                    style={{ color: "#045e51" }}
                    htmlFor="centerparcs-password"
                  >
                    {t("login:form.password.label")}
                  </Form.Label>
                  <Form.Control
                    type="password"
                    id="centerparcs-password"
                    size="lg"
                    className="border-0 rounded-pill"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                      border: "2px solid #045e51",
                      color: "#045e51",
                    }}
                    placeholder={t("login:form.password.placeholder")}
                    autoComplete="current-password"
                    {...register("password")}
                    isInvalid={!!errors.password}
                  />
                  <Form.Control.Feedback type="invalid">
                    {typeof errors.password?.message === "string"
                      ? errors.password.message
                      : null}
                  </Form.Control.Feedback>
                </Form.Group>

                <div>
                  <Button
                    type="submit"
                    className="w-100 rounded-pill py-3 mb-3 border-0 "
                    style={{
                      backgroundColor: "#045e51",
                      color: "#b1eda6",
                      fontSize: "16px",
                      fontWeight: "bold",
                      boxShadow: "none",
                    }}
                    onFocus={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow =
                        "0 0 0 0.2rem rgba(4, 94, 81, 0.25)";
                      e.currentTarget.style.outline = "none";
                    }}
                    onBlur={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow = "none";
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor = "#034a3d";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor = "#045e51";
                    }}
                  >
                    {t("login:button.submit")}
                  </Button>

                  <Button
                    as={Link}
                    to="/forgot-password"
                    className="w-100 rounded-pill py-3 text-decoration-none"
                    style={{
                      backgroundColor: "transparent",
                      border: "2px solid #045e51",
                      color: "#045e51",
                      fontSize: "16px",
                      fontWeight: "bold",
                      boxShadow: "none",
                    }}
                    onFocus={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow =
                        "0 0 0 0.2rem rgba(4, 94, 81, 0.25)";
                      e.currentTarget.style.outline = "none";
                    }}
                    onBlur={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow = "none";
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(4, 94, 81, 0.1)";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    {t("login:button.forgotPassword")}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CenterParcsLogin;
